import { getExecute, customGetExecute } from 'services/api/microfwk';
import { getCmsLevelUser, getCmsLevel } from 'services/api/cms/level';
import { getUserSeenDel } from 'services/api/user/seen';
import { getRibbon } from 'containers/MusicPage/service';
import * as ACTIONS from 'actions/carousel';
import Utils from 'utils/Utils';
import Metrics from 'services/metrics';
import { GetEpgVersion, tvEverywhereEnable } from '../utils/getEpgParams';

export const setContentList = result => ({
  type: ACTIONS.CONST_SET_CONTENT_LIST,
  result,
});
export const setCarouselData = result => ({
  type: ACTIONS.SET_CAROUSEL_DATA,
  result,
});
export const setCmsLevel = data => ({
  type: ACTIONS.CONST_SET_CMS_LEVEL,
  data,
});
export const setCmsLevelUser = data => ({
  type: ACTIONS.CONST_SET_CMS_LEVEL_USER,
  data,
});

export const pushCarrouselToStore = carrousel => ({
  type: ACTIONS.PUSH_CARROUSELS,
  carrousel,
});
export const extendCarrouselsToStore = result => ({
  type: ACTIONS.EXTEND_CARROUSELS,
  result,
});
export const setFavoritesToStore = favorites => ({
  type: ACTIONS.SET_FAVORITES,
  favorites,
});
export const flushStoreOverLoad = () => ({ type: ACTIONS.FLUSH_OVERLOAD });
export const setBackgroundToStore = data => ({
  type: ACTIONS.SET_BACKGROUND,
  data,
});
export const deleteFavoriteOnStore = favoriteId => ({
  type: ACTIONS.DELETE_FAVORITE,
  favoriteId,
});

export const fetchContentList = options => dispatch => {
  const params = Object.assign({}, options);
  let { url } = options;
  if (params.url === undefined) {
    getRibbon().then(data => {
      const result = { data, options };
      return dispatch(setCarouselData(result));
    });
  } else {
    const lasttouch = localStorage.getItem('lasttouchSeen');
    const LASTTOUCH_REGEX = /lasttouch=/g;
    if (params.url.indexOf('/services/user/seen?') !== -1 && lasttouch) {
      // Se valida si ya tenemos el lasttouch en la url de seen
      const alreadyHasLasttouch = LASTTOUCH_REGEX.test(url);
      // Si no está, se agrega desde el lasttouch de localStorage
      if (!alreadyHasLasttouch) url += `&lasttouch=${lasttouch}`;
    }

    if (options.isRecordingsCarousel) {
      customGetExecute(`${url}&api_version=v5.94`, options.params).then(response => {
        const { data } = response;
        if (
          data.status !== '0' &&
          data.status !== 200 &&
          data.status !== undefined
        )
          return console.log('Error api', url);
        const { _id } = params;
        const result = { _id, data, options };
        if (_id !== undefined) return dispatch(setContentList(result));
        return dispatch(setCarouselData(result));
      });
    } else {
      getExecute(url, options.params).then(data => {
        if (
          data.status !== '0' &&
          data.status !== 200 &&
          data.status !== undefined
        )
          return console.log('Error api', url);
        const { _id } = params;
        const result = { _id, data, options };
        if (_id !== undefined) return dispatch(setContentList(result));
        return dispatch(setCarouselData(result));
      });
    }
  }
};

export const saveFavorites = favorites => dispatch => {
  dispatch(setFavoritesToStore(favorites));
};

export const deleteFavorite = favoriteId => dispatch => {
  dispatch(deleteFavoriteOnStore(favoriteId));
};

export const pushCarrousel = options => dispatch => {
  if (options.simple) {
    return dispatch(pushCarrouselToStore(options.carrousel));
  }
  return dispatch(extendCarrouselsToStore(options.result));
};

export const flushOverLoad = () => dispatch => dispatch(flushStoreOverLoad());

export const setBackGround = options => dispatch => {
  const { source, active } = options;
  return dispatch(setBackgroundToStore({ source, active }));
};

export const saveSeen = seen => ({ type: ACTIONS.CONST_SET_SEEN, seen });

export const deleteSeenList = (group, metricsData) => async dispatch => {
  const userHash = localStorage.getItem('loginInfo.userhash');
  const resp = await getUserSeenDel({
    object_id: group.id,
    user_hash: userHash,
    object_type: 1,
  });

  if (resp.status !== '0') return;
  Metrics.newEvent({
    eventCategory: 'Remover de Carrusel',
    eventAction: metricsData.section,
    eventLabel: `${group?.format_types} - ${group?.title} – ${metricsData?.index
    } | Continúa viendo`,
  });
  dispatch({
    type: ACTIONS.REMOVE_SEEN_CAROUSEL,
    group: group.id,
  });
};
